import { initReactI18next } from 'react-i18next'

import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'
import { NS } from 'src/constants/i18n'
import { SUPPORTED_LANGUAGES } from 'src/constants/locale'
import { getCurrentLanguage } from 'src/utils/locale/getCurrentLanguage'

// Keep <html lang> in sync so assistive tech reads the page in the active language
i18n.on('languageChanged', () => {
  document.documentElement.lang = getCurrentLanguage(i18n)
})

// eslint-disable-next-line import/no-named-as-default-member
i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: SUPPORTED_LANGUAGES.EN,
    supportedLngs: Object.values(SUPPORTED_LANGUAGES),
    load: 'languageOnly',
    preload: Object.values(SUPPORTED_LANGUAGES),
    ns: Object.values(NS),
    debug: false,
    interpolation: { escapeValue: false },
    backend: { loadPath: '/locales/{{lng}}/{{ns}}.json' },
    saveMissing: import.meta.env.DEV,

    // This runs automatically whenever a key is missing in the active language
    missingKeyHandler: (lngs, ns, key) => {
      // Only log warnings during local development to keep production logs clean
      if (import.meta.env.DEV) {
        console.warn(
          `⚠️ [i18n Missing Key]: Language "${lngs.join(', ')}" is missing key "${key}" in namespace "${ns}".`,
        )
      }
    },
  })

export default i18n
